import { render, staticRenderFns } from "./InactiveAccount.vue?vue&type=template&id=9a5202ba&"
import script from "./InactiveAccount.vue?vue&type=script&lang=js&"
export * from "./InactiveAccount.vue?vue&type=script&lang=js&"
import style0 from "./InactiveAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports